import { createTracker } from 'usage-tracker-public';
import events from '../../events.yaml';
import { makeUuid } from 'usage-tracker-core/common/helpers';
const sessionId = makeUuid();
export default createTracker({
  events,
  properties: {
    deviceId: sessionId
  }
});